import * as React from 'react';
import { Button as BaseButton, Tooltip } from 'antd';
import { EditFilled } from '@ant-design/icons';



const EditButton = ({ tooltipText, style, disabled, onClick, notFilled }) => {
    return (
        <Tooltip placement="top" title={tooltipText}>

            {
                notFilled ? <EditFilled
                        className={'_hover-primary-icon'}
                        style={style || {}}
                        onClick={onClick}
                    /> :
                    <BaseButton
                        type={'primary'}
                        shape="circle"
                        disabled={disabled}
                        size="large"
                        style={style || {}}
                        onClick={onClick}
                        icon={<EditFilled/>}
                    />
            }
        </Tooltip>

    );
};
export default EditButton;